import { render, staticRenderFns } from "./video-backgrounds.html?vue&type=template&id=0dafebb4&"
import script from "./video-backgrounds.js?vue&type=script&lang=js&"
export * from "./video-backgrounds.js?vue&type=script&lang=js&"
import style0 from "./video-backgrounds.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports